import { compose, isNil, modify, modifyPath } from 'ramda';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import { useState } from 'react';
import { dateTimeToMidday, FORMAT_DATE_FR } from '@@viewHelpers/date.js';
import useSaveSouscriptionInformationsMutation from './useSaveSouscriptionInformationsMutation.js';
import moment from 'moment';
import { orderPhonesByType } from '@@viewHelpers/phone.js';

const useSouscriptionInformationsForm = () => {
  const [loading, setLoading] = useState(false);
  const { processHandlers, context } = useProcess();

  const formatBirthDateToString = modify('birthDate', (birthDate) =>
    dateTimeToMidday(birthDate).valueOf().toString()
  );

  const saveSouscriptionInformations = useSaveSouscriptionInformationsMutation();

  const onSubmit = (values) => {
    if (loading) return;
    setLoading(true);

    saveSouscriptionInformations.onFormSubmit(formatBirthDateToString(values), (ok, error) => {
      if (ok && !error) {
        processHandlers.onNext({
          context: {
            projectId: context?.projectId
          }
        });
      } else {
        setLoading(false);
      }
    });
  };

  const onPrevious = () => {
    processHandlers.onPrev({
      context: {
        projectId: context?.projectId
      }
    });
  };

  const formatDate = (date) => (isNil(date) ? null : moment(date, FORMAT_DATE_FR).toDate());

  const formatCustomer = compose(
    modifyPath(['customer', 'phones'], orderPhonesByType),
    modifyPath(['customer', 'birthDate'], formatDate)
  );

  return {
    onSubmit,
    onPrevious,
    formatCustomer
  };
};

export default useSouscriptionInformationsForm;
